import React from "react";
import { useStyles } from "../../assets/jss/Breadcrumb";
// import CustomLink from "../CustomComponents/CustomLink/CustomLink";
import { NavLink } from "react-router-dom";
import CustomBox from "../CustomComponents/CustomBox/CustomBox";
import CustomDivider from "../CustomComponents/CustomDivider/CustomDivider";
import { useTranslation } from "react-i18next";

export default function Breadcrumb(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <CustomBox className={classes.breadcrumb}>
      {props.showAdmin &&
        <>
          <NavLink to={"/admin"} className={classes.breadcrumbLink}>{t("ADMIN")}</NavLink>
          <CustomDivider className={classes.breadcrumbSeparator} orientation="vertical" />
        </>
      }
      {
        props && props.currentPage
      }
    </CustomBox>
  );
}
